import { inject } from '@angular/core';
import { AppearanceStore } from '@marineform/manage-data-access';

export function manageAppearanceInitializer() {
  inject(AppearanceStore);
}
